'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _cookie = require('./cookie');

var _cookie2 = _interopRequireDefault(_cookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COOKIE = 'aep_history';
var KEYWORDS_GROUP = 'keywords';
var PRODUCT_GROUP = 'product_selloffer';
var SEP_GROUP = '\n\n'; // 组之间的分隔符
var SEP_GROUP_NAME = '^\n'; // 组名与项目分隔符
// const SEP_GROUP_ITEM = '$\n'; // 组里面的项目之间的分隔符
var SEP_ATTR = '\t'; // 项目里面属性之间的分隔符

/**
 * 用于录入和读取 AliExpress 的历史浏览记录对象
 */

var WsHistory = function () {

    // 最近浏览产品的数量
    function WsHistory() {
        (0, _classCallCheck3.default)(this, WsHistory);
        this.keywordsSize = 8;
        this.productsSize = 8;
        this.groups = {};

        this.refresh();
    }

    /**
     * 返回最近用过的搜索关键字组合
     */


    // 内容分组

    // 搜索关键字组合的数量


    (0, _createClass3.default)(WsHistory, [{
        key: 'getKeywords',
        value: function getKeywords() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            if (!this.groups || !this.groups[KEYWORDS_GROUP]) {
                return [];
            }

            var limit = options.limit || 0; // 列表长度

            // 如果倒序, 按 Cookie 内顺序输出
            var keywords = this._sliceArray(this.groups[KEYWORDS_GROUP], limit).slice(0);
            return keywords;
        }

        /**
        * 返回最近访问过的商品 ID
        */

    }, {
        key: 'getProducts',
        value: function getProducts() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            if (!this.groups || !this.groups[PRODUCT_GROUP]) {
                return [];
            }

            var limit = options.limit || 0; // 列表长度

            var urls = this._sliceArray(this.groups[PRODUCT_GROUP], limit);

            /*
             * 以下循环处理代码是为了兼容以前不规范的 Cookie 内容
             * 2013 年 5 月 17 日已经发布修复线上的处理, 建议一年后不需继续兼容, 即 2014 年 5 月之后可以删除这段代码
             */
            var ids = [];
            for (var i = 0, len = urls.length; i < len; i++) {
                var id = urls[i].replace(/^http(s)?:\/\/.*\/(\d+_)?|\.html.*$/gi, '');
                // 如果不是全数字, 说明不是正确的商品 ID, 过滤掉
                if (/^\d+$/.test(id)) {
                    ids.push(id);
                }
            }
            // var ids = urls.slice(0);

            return ids;
        }

        /**
         * 记录一个商品
         */

    }, {
        key: 'logProduct',
        value: function logProduct(options) {
            // 如果没有传参进来, 不做任何处理
            if (!options || !options.id) {
                return;
            }

            // 为商品数组加入新的项目
            var productArray = this._addItem({
                array: this.getProducts(),
                item: options.id,
                maxSize: this.productsSize
            });

            // 构建新的 cookie 字符串
            var newCookie = this._buildWholeCookie({
                keywordArray: this.getKeywords(),
                productArray: productArray
            });

            // 更新到 cookie 中
            _cookie2.default.set(COOKIE, newCookie, {
                domain: 'aliexpress.com',
                path: '/',
                expires: 365 // cookie 保留 1 年
            });

            // 刚刚添加过内容, 刷新一下
            this.refresh();
        }

        /**
        * 刷新内容
        */

    }, {
        key: 'refresh',
        value: function refresh() {
            this.groups = this._parseGroups();
        }

        /**
         * 构建整个 Cookie
         */

    }, {
        key: '_buildWholeCookie',
        value: function _buildWholeCookie(options) {
            var keywordArray = options.keywordArray || []; // 关键字数组
            var productArray = options.productArray || []; // 商品数组

            var keywordGroup = this._buildGroup({
                group: KEYWORDS_GROUP,
                array: keywordArray.reverse() // 因为获取的串是倒置的, 还原时需要再倒置一次
            });
            var productGroup = this._buildGroup({
                group: PRODUCT_GROUP,
                array: productArray.reverse() // 因为获取的串是倒置的, 还原时需要再倒置一次
            });

            return keywordGroup + SEP_GROUP + productGroup;
        }

        /**
         * 构建一个组
         */

    }, {
        key: '_buildGroup',
        value: function _buildGroup(options) {
            var group = options.group || ''; // 分组名称
            var array = options.array || []; // 内容数组

            // 如果没有分组名, 直接返回空串
            if (!group || group.length <= 0) {
                return '';
            }

            /*
            group^
            group   item1   item2   item3   item4   item5   ...
            */
            return group + SEP_GROUP_NAME + group + SEP_ATTR + array.join(SEP_ATTR);
        }

        /**
         * 添增一个新的项目
         */

    }, {
        key: '_addItem',
        value: function _addItem(options) {
            var array = options.array || []; // 内容数组
            var item = options.item || ''; // 添加项目
            var maxSize = options.maxSize || ''; // 列表最大长度

            // 如果没有项目, 直接返回原来数组
            if (!item || item.length <= 0) {
                return array;
            }

            // 拷贝数组作为新数组 (避免对原内容造成影响)
            var newArray = array.slice(0);

            // 先转回来, 加入新增节点
            newArray = newArray.reverse();
            this._appendToArray(item, newArray);

            // 再倒置列表, 去除多余部分
            newArray = newArray.reverse().splice(0, maxSize);

            return newArray;
        }

        /**
         * 将数组元素加入最后, 并去重
         */

    }, {
        key: '_appendToArray',
        value: function _appendToArray(item, array) {
            if (!Array.isArray(array)) {
                return;
            }
            var index = array.indexOf(item);
            if (index >= 0) {
                array.splice(index, 1);
            }
            array.push(item);
        }

        /**
         * 拆切数组
         */

    }, {
        key: '_sliceArray',
        value: function _sliceArray(array, limit) {
            if (limit > 0) {
                return array.splice(0, limit);
            }
            return array;
        }

        /**
        * 获取组
        */

    }, {
        key: '_parseGroups',
        value: function _parseGroups() {
            var groups = {};

            var cookie = _cookie2.default.get(COOKIE, {
                domain: 'aliexpress.com',
                path: '/'
            });

            if (cookie) {
                var list = cookie.split(SEP_GROUP);
                for (var i = 0, len = list.length; i < len; i++) {
                    var item = list[i].split(SEP_GROUP_NAME);

                    var key = item[0];
                    var value = item[1];
                    var content = this._parseGroupContent(key, value);
                    groups[key] = content;
                }
            }

            return groups;
        }

        /**
        * 获取组中的内容数组
        */

    }, {
        key: '_parseGroupContent',
        value: function _parseGroupContent(key, str) {
            // 如果没有值, 则返回空数组
            if (!str || str.length === 0) {
                return [];
            }

            var index = str.indexOf(key);
            if (index >= 0) {
                str = str.substring(index + key.length + SEP_ATTR.length);
            }

            var array = str.split(SEP_ATTR);
            array = array.reverse(); // 倒序, 因为录入时是追加的, 最近内容展示顺序应该反过来
            array = this._uniqueArray(array); // 去重

            return array;
        }
    }, {
        key: '_uniqueArray',
        value: function _uniqueArray(array) {
            var results = array;
            for (var i = 1; i < results.length; i++) {
                if (results[i] === results[i - 1]) {
                    results.splice(i--, 1); // eslint-disable-line
                }
            }
            return results;
        }
    }]);
    return WsHistory;
}();

exports.default = new WsHistory();